import { LoadState } from "../../constants/enum";
import { getUniqueId } from "../../helpers";
import { IAutomationState, ICreateWorkflow, IWorkFlowAction, IWorkFlowCondition, IWorkflowFinishEmail } from "./automation.types";

export const initialAutomationState: IAutomationState = {
    graphData: {
      nodes: [],
      edges: [],
      workflow_basic_code: null,
    },
    graphLoadState: LoadState.idle,
    list: [],
    totalRecords: 0,
    loading: LoadState.idle,
  };
  
  export const initialAutomationParentNode: ICreateWorkflow = {
    workflow_basic_code: null,
    run_as: null,
    endpoint_path: null,
    module_name: null,
    real_time_type: null,
    workflow_name: null,
    cron_schedule_at: {
      date: null,
      hour: null,
      minute: null,
      month: null,
      repeatEvery: false,
      second: null,
      week: null
    },
    status: "ACTIVE",
    nodes: {
      id: getUniqueId(),
      data: { label: "Start Workflow" },
      position: { x: 100, y: 150 },
      type: "parentWorkflowNode",
      height: 100,
      width: 170,
    },
    edges: [],
    outlet_uuid: null,
    outlet_name: null
  };
  
  export const intitalWorkflowConditionNode: IWorkFlowCondition = {
    workflow_condition_code: null,
    workflow_basic_code: "",
    call_type: null,
    conditions: [
      {
        and: [],
      },
    ],
    ui_module_name: "",
    ui_related: [
      {
        and: {
          rows: [],
        },
      },
    ],
    sql_statement: null,
    condition_variables: [],
    status: "ACTIVE",
    nodes: {
      id: "",
      data: { label: "" },
      type: "conditionNode",
      position: { x: 0, y: 0 },
      height: 100,
      width: 170,
    },
    outlet_uuid: null,
    outlet_name: null
  };
  
  export const intitialWorkFlowActionNode: IWorkFlowAction = {
    workflow_action_code: null,
    workflow_basic_code: "",
    workflow_condition_code: null,
    action_type: null,
    comment: null,
    status: "ACTIVE",
    nodes: {
      id: "",
      data: { label: "" },
      type: "conditionNode",
      position: { x: 0, y: 0 },
      height: 100,
      width: 170,
    },
    outlet_uuid: null,
    outlet_name: null
  };
  export const intitialWorkFinishEmailActionNode: IWorkflowFinishEmail = {
    workflow_action_email_code: null,
    workflow_action_code: "",
    emailsTo: [],
    emailsCC: [],
    emailsBCC: [],
    variablesTo: [],
    variablesCC: [],
    variablesBCC: [],
    apiTo: [],
    apiCC: [],
    apiBCC: [],
    call_type: "VARIABLE",
    sending_order: "ONE_BY_ONE",
    workflow_basic_code: "",
    template_code: null,
    nodes: {
      id: "",
      data: { label: "" },
      type: "performEmailAction",
      position: { x: 0, y: 0 },
      height: 100,
      width: 170,
    },
    status: "ACTIVE",
  };
  